import { ThemeConfigType } from '@themes/themeTypes';

export const themeConfig: ThemeConfigType = {
  light: {
    '--primary': '#e6e6ea',
    '--secondary': '#f4f4f8',
    '--text-muted-2': '#6A7181',

    '--accent': '#0009E8',
    '--accent-900': '#CCD2F4',
    '--accent-800': '#A2ACEC',
    '--accent-700': '#7886E3',
    '--accent-600': '#4E60DA',
    '--accent-500': '#2A3FCB',
    '--accent-400': '#2132A1',
    '--accent-300': '#192576',
    '--accent-200': '#10184C',
    '--accent-100': '#070B22',

    '--error': '#AB2B2B',
    '--warning': '#A39533',
    '--info': '#0009E8',
    '--success': '#33A389',

    '--highlight': '#0009E8',

    //bg-colors
    '--bg-primary': '#FFF',
    '--bg-primary-transparent': '#FFFFFFCC',
    '--bg-input': '#F4F4F8',
    '--bg-light-blue': '#E9F4FB',

    //text colors
    '--text-primary': '#051129',
    '--text-secondary': '#1e293b',
    '--text-dark': '#192039',
    '--text-muted': '#414753',
    '--text-muted2': '#6c727e',
    '--text-highlight': '#7c8eff',
    '--text-button': '#FFF',
    '--text-accent': '#0009E8',
    '--text-dark-blue': '#000061',

    '--bg-muted-transparent': 'rgba(223, 225, 229, 0.5)',

    //border-colors
    '--border-primary': '#E0E0E0',
    '--border-blue-transparent': 'rgba(35, 132, 194, 0.3)',

    //gradients
    '--gradient-primary': '#2B40CC',
    '--gradient-secondary': '#97A4FA',

    //button
    '--bg-button-primary': '#0009E8',

    //fill
    '--fill-black': '#000',

    //Not in figma colors
    '--nif-highlight': '#FF990080',
    '--nif-highlight-2': '#FAFF0080',

    // Figma shadows
    '--dropdown': '1px 2px 8px 2px rgba(18, 19, 21, 0.1)',
    '--modal': '0px 5px 22px 0px rgba(66, 67, 71, 0.3)',
    '--small': '0px 1px 5px 0px rgba(209, 212, 235, 0.4)',
    '--small-inset': '0px 1px 5px 0px rgba(209, 212, 235, 0.4) inset',
    '--tooltip': '0px 2px 6px 1px rgba(51, 51, 51, 0.3)',
    '--special': '0px 1px 3px 0px rgba(0, 0, 0, 0.14)',
    '--small-inner-shadow-special': '0 0 3px 0 rgba(184, 191, 205, 1)',
    '--toggler-small': '0px 0px 2px 0px rgba(184, 191, 205, 1)',
    '--social-media-inner': '-1px -1px 4px 0px rgba(223, 224, 232, 1) inset',
    '--selected-social-inner': '0px 1px 4px 0px rgba(200, 200, 212, 1) inset',
    '--small-dark-toggle': '0px 4px 4px 0px rgba(18, 19, 21, 0.1)',
    '--ui': '0px 5px 22px 0px rgba(209, 212, 235, 0.4)',
    '--side-pannel': '-8px 0px 9px 0px  rgba(255, 255, 255, 0.60)',
  },

  dark: {
    '--primary': '#192039',
    '--secondary': '#202848',
    '--text-muted-2': '#6A7181',

    '--accent': '#0009E8',
    '--accent-900': '#CCD2F4',
    '--accent-800': '#A2ACEC',
    '--accent-700': '#7886E3',
    '--accent-600': '#4E60DA',
    '--accent-500': '#2A3FCB',
    '--accent-400': '#2132A1',
    '--accent-300': '#192576',
    '--accent-200': '#10184C',
    '--accent-100': '#070B22',

    '--error': '#AB2B2B',
    '--warning': '#A39533',
    '--info': '#3362A3',
    '--success': '#33A389',

    '--highlight': '#7c8eff',

    //bg-colors
    '--bg-primary': '#111212',
    '--bg-primary-transparent': '#111321CC',
    '--bg-input': '#16171D',
    '--bg-secondary': '#202848',

    //text
    '--text-light': '#F1F3F9', //text light
    '--text-primary': '#F1F3F9',
    '--text-secondary': '#f1f5f9',
    '--text-dark': '#192039',
    '--text-muted': '#A2A8C3', //text disabled
    '--text-accent': '#5364D3',
    '--text-button': '#F1F3F9',

    //border-colors
    '--border-primary': '#262B36',

    //gradients
    '--gradient-primary': '#2B40CC',
    '--gradient-secondary': '#97A4FA',

    //button
    '--bg-button-primary': '#2A3FCB',

    //Not in figma colors
    '--nif-highlight': '#FF990080',
    '--nif-highlight-2': '#FAFF0080',

    '--bg-muted-transparent': 'rgba(0, 0, 0, 0.5)',

    // Figma shadows
    '--dropdown': '1px 2px 8px 2px rgba(23, 26, 32, 1)',
    '--modal': '0 5px 22px 0 rgba(17, 18, 20, 1)',
    '--ui': '0 5px 22px 0px rgba(17, 18, 20, 1)',
    '--small': '0px 1px 5px 0px rgba(21, 25, 30, 1)',
    '--small-inset': '0px 1px 5px 0px rgba(21, 25, 30, 1) inset',
    '--tooltip': '0px 2px 6px 1px rgba(19, 20, 23, 0.6)',
    '--special': '0px 1px 3px 0px rgba(0, 0, 0, 0.3)',
    '--small-inner-special': '0px 0px 3px 0 rgba(184, 191, 205, 1)',
    '--toggler-small': '0px 0px 2px 0 rgba(184, 191, 205, 1)',
    '--social-media-inner': '-1px -1px 4px 0px rgba(44, 53, 63, 1) inset',
    '--selected-social-inner': '0px 1px 4px 0px rgba(21, 28, 40, 1) inset',
    '--small-dark-toggle': '0px 4px 4px 0px rgba(18, 19, 21, 0.1)',
    '--side-pannel': '-8px 0px 9px 0px  rgba(0, 0, 0, 0.60)',
  },
};
